import logger from 'shared/services/logger'

interface ImageFinalProps {
  imageMinWidth?: number
  imageMaxWidth?: number
  imageSizes?: object
}

export const getFinalImageProps = (
  imageMinWidth: number | undefined,
  imageMaxWidth: number | undefined,
  imageSizes: string | undefined
): ImageFinalProps => {
  const finalProps: ImageFinalProps = {}

  try {
    if (imageSizes != null) {
      finalProps.imageSizes =
        typeof imageSizes === 'string' ? JSON.parse(imageSizes) : imageSizes
    }
    if (imageMinWidth != null) {
      finalProps.imageMinWidth = imageMinWidth
    }
    if (imageMaxWidth != null) {
      finalProps.imageMaxWidth = imageMaxWidth
    }
  } catch (error) {
    logger.error(error)
  }

  return finalProps
}
